import { Component } from '@angular/core';

@Component({
  selector: 'app-header-landingpage',
  templateUrl: './header-landingpage.component.html',
  styleUrls: ['./header-landingpage.component.css']
})
export class HeaderLandingpageComponent {

}
